import { useOrgData } from "../../../../../../contexts/OrgDataContext";
import { getText, LOGS_TYPES } from "../../../../../../services/log/log-service";
import { useMemo } from "react";
import moment from "moment/moment";
import { ArrowRightIcon, ExclamationTriangleIcon, InformationCircleIcon } from "@heroicons/react/20/solid";
import Badge from "../../../../../../components/badges/Badge";
import { useJournal } from "../../../../../../contexts/JournalContext";

const NEW_MODULE_SUBTYPE = 500;

export const ExailLog = ({ log, patternExecutions }) => {

  console.log(log);

  const { type, time } = log;
  const { eventTypes } = useOrgData();
  const { selectedDisplayOption } = useJournal();

  const isNewModule = log.subtype === NEW_MODULE_SUBTYPE;
  const isInModule = log?.data_module_id !== null && log?.data_module_id !== undefined;

  let patternExecutionName = 'Pièce hors gamme';
  if (isInModule) patternExecutionName = 'Module #' + log.data_module_id;

  const isAlert = type === LOGS_TYPES.ALERT;

  const circleColor = isAlert ? 'bg-perception-error-500' : 'bg-perception-black-900';
  const textColor = isNewModule ? 'text-perception-blue font-medium' : isAlert ? 'text-perception-error-500 font-medium' : '';

  return useMemo(() => (
    <div className="ml-8 border-l-1 border-perception-gray-600 relative flex pb-2 pr-4">

      {/* Circle */}
      <div className="absolute size-3 top-0 -left-1.5 rounded-full bg-perception-gray-500">
        <div className={`size-2 ${circleColor} absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-full`}/>
      </div>

      {/* Datetime */}
      <div className="text-sm -mt-1 w-32 text-center">
        {moment(time).format('HH:mm:ss')}
      </div>

      {/* Log content */}
      {/*<div className="flex-1 bg-perception-black-800 px-4 pr-1 py-1 rounded-md flex justify-between items-center gap-2">*/}
      <div className={`flex-1 bg-perception-black-800 px-4 pr-1 ${isNewModule ? 'border-1 border-l-8 border-perception-blue py-3 mb-4' : 'py-1'} rounded-md flex justify-between items-center gap-2`}>
        <div className="flex items-center gap-4 min-w-0">
          {
            isAlert ?
              <ExclamationTriangleIcon className={`size-4 min-w-4 ${textColor}`}/>
            : isNewModule ?
              <ArrowRightIcon className={`size-4 min-w-4 ${textColor}`}/>
            :
              <InformationCircleIcon className={`size-4 min-w-4 ${textColor}`}/>
          }
          <div className={`text-sm ${textColor} flex gap-2 flex items-center`}>
            {!isNewModule && <Badge text={patternExecutionName} type={isInModule && 'purple'} />}
            {getText(log, {}, true, eventTypes)}
            {isNewModule && log.data_module_id && ' (Module #' + log.data_module_id + ')'}
            {
              log?.data_action_duration &&
                <Badge text={`Duration: ${Math.round(log.data_action_duration*10)/10}s`}/>
            }
          </div>
        </div>
        <div className="flex gap-2 flex-1">
          {isAlert &&
            <div className="w-full flex justify-end">
              <Badge text="Alerte levée" type="red" />
            </div>
          }
        </div>
      </div>

    </div>
  ), [log, eventTypes]);
};